import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgParamEclipticTilt = (props) => /* @__PURE__ */ _jsx("svg", {
	preserveAspectRatio: "none",
	width: "100%",
	height: "100%",
	overflow: "visible",
	style: { display: "block" },
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Icon",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Union",
			d: "M11.999 2.85059C14.4251 2.85067 16.7522 3.81474 18.4678 5.53027C20.1832 7.24585 21.1465 9.57294 21.1465 11.999C21.1464 13.2003 20.9099 14.3902 20.4502 15.5C19.9905 16.6097 19.3171 17.6184 18.4678 18.4678C17.6184 19.3171 16.6097 19.9905 15.5 20.4502C14.3902 20.9099 13.2003 21.1464 11.999 21.1465C10.7977 21.1465 9.60793 20.9099 8.49805 20.4502C7.38828 19.9905 6.37969 19.3171 5.53027 18.4678C4.68089 17.6184 4.00661 16.6098 3.54688 15.5C3.08718 14.3902 2.85063 13.2003 2.85059 11.999C2.85059 9.57278 3.81466 7.24588 5.53027 5.53027C7.24588 3.81466 9.57278 2.85059 11.999 2.85059ZM8.9834 19.6055C9.94309 19.9858 10.966 20.1836 11.999 20.1836C13.0738 20.1836 14.1379 19.9718 15.1309 19.5605C16.1239 19.1492 17.0261 18.5462 17.7861 17.7861C18.5462 17.0261 19.1492 16.1239 19.5605 15.1309C19.9102 14.2868 20.1142 13.3912 20.168 12.4814H12.3057L8.9834 19.6055ZM3.8291 12.4814C3.88287 13.3912 4.08693 14.2868 4.43652 15.1309C4.84784 16.1239 5.45095 17.0261 6.21094 17.7861C6.77276 18.348 7.41289 18.823 8.10938 19.1992L11.2432 12.4814H3.8291ZM12.7549 11.5186H20.168C20.0507 9.52292 19.2075 7.6323 17.7861 6.21094C17.2202 5.645 16.5794 5.17144 15.8877 4.79785L12.7549 11.5186ZM11.999 3.81348C9.82818 3.81348 7.74596 4.67592 6.21094 6.21094C4.78957 7.6323 3.9464 9.52292 3.8291 11.5186H11.6924L15.0146 4.3916C14.0636 4.01445 13.042 3.81352 11.999 3.81348Z",
			fill: "var(--fill-0, #DFCBF5)",
			fillOpacity: .7
		})
	})
});
export default SvgParamEclipticTilt;
